import { Input, Button, Icon } from '@driftt/tide-core-legacy'
import IconSVG from 'svg-inline-react'

import UIDropArea from 'components/shared/UIDropArea'
import LoadingDots from 'components/shared/LoadingDots'
import TinyEditor from 'components/playbook/components/TinyEditor'
import Card from 'components/playbook/components/Card'
import pictureDrawingSrc from '!svg-inline?removeTags=true!images/svg/picture-drawing.svg'
import MultiSignaturePreview from '../MultiSignaturePreview'

import './style.styl'


const AlsoIncludeSection = ({
  signatureIncludeAvatar,
  signatureIncludeSocial,
  signatureIncludeBanner,
  onIncludeAvatarChange,
  onIncludeSocialChange,
  onIncludeBannerChange,
}) => (
  <div className="signature-editor-also-include">
    <h3 className="signature-editor-also-include-title">Also Include:</h3>
    <div className="signature-editor-also-include-wrapper">
      <div className="signature-editor-option">
        <Input type="checkbox" onChange={onIncludeAvatarChange} checked={signatureIncludeAvatar} />
        <label className="signature-editor-option-label">Avatar</label>
      </div>
      <div className="signature-editor-option">
        <Input type="checkbox" onChange={onIncludeSocialChange} checked={signatureIncludeSocial} />
        <label className="signature-editor-option-label">Company Social Media</label>
      </div>
      <div className="signature-editor-option">
        <Input type="checkbox" onChange={onIncludeBannerChange} checked={signatureIncludeBanner} />
        <label className="signature-editor-option-label">Banner Graphic</label>
      </div>
    </div>
  </div>
)

const BannerSettings = ({
  onBannerUpload,
  onBannerLinkURLChange,
  onClearSignatureBanner,
  onIncludeNoBannerOption,
  emptyBannerChecked,
  onAddNewBanner,
  onRemoveSignatureClick,
  signatureIncludeBanner,
  signatureBannerUploadPending,
  signatures,
}) => (
  signatureIncludeBanner &&
  <div>
    {signatures.toList().map((signature, i) => (
      signature.hasCampaignGraphic &&
        <div className="playbook-signature-banner-customize" key={signature.id}>
          <div className="playbook-signature-remove-signature-container">
            <div className="playbook-signature-remove-signature" onClick={() => onRemoveSignatureClick(signature.id, signatures.size)}>
              <Icon name="cancel-circle" /><p>Remove this option</p>
            </div>
          </div>
          <UIDropArea
            onDrop={(files) => onBannerUpload(files, signature.id)}
            onClear={e => onClearSignatureBanner(e, signature)}
            shouldRenderClear={false}
            shouldRenderPreview={false}
            className="playbook-email-edit-banner-drop-area"
            disabled={!!signature.campaignGraphic}
          >
            {!!signature.campaignGraphic &&
              <div className="playbook-signature-edit-banner-drop-area">
                <img src={signature.campaignGraphic} />
              </div>
            }
            {!signature.campaignGraphic &&
              <div className="playbook-email-edit-banner-drop-zone playbook-signature-edit-banner-drop-area">
                <div>
                  <span className="playbook-email-edit-empty-banner-icon">
                    <IconSVG src={pictureDrawingSrc} width={"20px"} />
                  </span>
                  {!signatureBannerUploadPending &&
                  <div>
                    <div className="playbook-email-edit-banner-title">Drag and drop or <span className="link">Upload a Graphic</span></div>
                  </div>
                  }
                  {signatureBannerUploadPending &&
                    <div>
                      <div className="playbook-email-edit-banner-title">Uploading your banner image.</div>
                      <div className="playbook-email-edit-banner-upload-loading-container"><LoadingDots /></div>
                    </div>
                  }
                </div>
                <div className="playbook-edit-banner-help-text">
                  <p>Keep in mind that your image will be shrunk to 450px wide in the email.</p>
                </div>
              </div>
            }
          </UIDropArea>
          <div className="playbook-signature-edit-banner-link">
            <p className="playbook-signature-edit-banner-link-title">Image Link</p>
            <p className="playbook-signature-edit-banner-link-helptext">The link users are taken to when they click the campaign banner</p>
            <Input value={signature.campaignGraphicLink || ''} onChange={e => onBannerLinkURLChange(e, signature.id)} placeholder="link for people who click the image" />
          </div>
        </div>
    )).toJS()}
    <div className="playbook-signature-add-more-section">
      <Button className="playbook-signature-add-more-button" onClick={onAddNewBanner} disabled={signatures.size >= 5}>+ Add Another</Button>
      {(signatures.size < 5 || emptyBannerChecked) &&
        <div className="signature-editor-option signature-editor-empty-option">
          <Input type="checkbox" checked={emptyBannerChecked} onChange={onIncludeNoBannerOption} />
          <label className="signature-editor-option-label">Include a "No Banner" Option</label>
        </div>
      }
      {signatures.size < 5 &&
        <p className="playbook-signature-banner-count">You can add up to { `${5 - signatures.size}` } more banner{ 5 - signatures.size > 1 ? 's' : '' }</p>
      }
      {signatures.size >= 5 &&
        <p className="playbook-signature-banner-count">You have added all 5 allowed banner options.</p>
      }
      </div>
  </div>
)


const MiniSignaturePreview = ({
  signaturePreviewContent,
  signaturePreviewFetchFailed,
  signaturePreviewFetchPending,
}) => (
  <div>
    <div className="playbook-signature-editor-preview-loading-container">
      {signaturePreviewFetchPending &&
        <div className="playbook-signature-editor-preview-loading">Fetching updated preview<LoadingDots /></div>
      }
      {signaturePreviewFetchFailed &&
        <div className="playbook-signature-editor-preview-failed">Could not fetch the newest preview, check your signature for any errors</div>
      }
    </div>
    <div dangerouslySetInnerHTML={{ __html: signaturePreviewContent }} />
  </div>
)


const SignatureEditor = ({
  signatureBody,
  onContentChange,
  ...props,
}) => (
  <div>
    <Card title="Configure Template">
      <TinyEditor
        initialContent={signatureBody}
        onChange={onContentChange}
        showPersonalization={true}
        showSignature={false}
        includeColorAndSize={true}
        includeAlignment={false}
      />
      <AlsoIncludeSection {...props} />
      <BannerSettings {...props} />
      <div className="signature-editor-mini-preview">
        <div className="playbook-card-no-padding signature-editor-mini-preview-title">PREVIEW</div>
          <MultiSignaturePreview
            multiSignature={props.signaturePreviewAllData}
            multiSignaturePreviewFetchPending={props.signaturePreviewAllFetchPending}
            multiSignaturePreviewFetchFailed={props.signaturePreviewAllFetchFailed}
            onRefetchClick={props.onRefetchPreviewClick}
          />
      </div>
    </Card>
  </div>
)


export default SignatureEditor



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/SignatureEditor/component.js